import React from 'react'
import TinyBarChartPanel from '../../../components/Charts/TinyBarChartPanel';
import FilterPanel from '../components/FilterPanel';

const BettingReportByMix = () => {
  return (
     <div className='p-2'>
     <div className='flex justify-between border-b border-b-gray-300 pb-2'>
         <h6 className="font-semibold">Betting Report By Mix</h6>
         <FilterPanel />
     </div>
         <div className="w-[70%] h-[250px]">
         <TinyBarChartPanel/>
         </div>
 </div>
  )
}

export default BettingReportByMix;